import person from "../../assets/person.png";

export const persons = [
  {
    children: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque, duis tellus nec aliquam volutpat.\n' +
      '        Dui dictum tortor dapibus integer convallis ut facilisi leo semper.',
    img: person,
    name: 'Saul Ramirez',
    workplace: 'CEO, Mirrorly'
  },
  {
    children: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque, duis tellus nec aliquam volutpat.\n' +
      '        Dui dictum tortor dapibus integer convallis ut facilisi leo semper.',
    img: person,
    name: 'Isiah Walls',
    workplace: 'Marketing Lead, Zambora'
  },
  {
    children: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque, duis tellus nec aliquam volutpat.\n' +
      '        Dui dictum tortor dapibus integer convallis ut facilisi leo semper.',
    img: person,
    name: 'Forest Barrera',
    workplace: 'Managing Director, Teri'
  },
  {
    children: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque, duis tellus nec aliquam volutpat.\n' +
      '        Dui dictum tortor dapibus integer convallis ut facilisi leo semper.',
    img: person,
    name: 'Ruby Schwartz',
    workplace: 'Marketing Intern, Thornton'
  },
  {
    children: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque, duis tellus nec aliquam volutpat.\n' +
      '        Dui dictum tortor dapibus integer convallis ut facilisi leo semper.',
    img: person,
    name: 'Isaias Martinez',
    workplace: 'Head of Marketing, Moore'
  },
  {
    children: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neque, duis tellus nec aliquam volutpat.\n' +
      '        Dui dictum tortor dapibus integer convallis ut facilisi leo semper.',
    img: person,
    name: 'Deidre Braun',
    workplace: 'CEO, WilBert'
  }
];
